import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DisplayableItemListComponent } from '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component';
import { PrintProductTemplatesViewModel } from '../print-product-templates-view-model';

@Component({
  selector: 'app-print-product-template-list',
  templateUrl:
    '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component.html',
  styleUrls: [
    '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component.scss',
    './print-product-template-list.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PrintProductTemplateListComponent extends DisplayableItemListComponent {
  constructor(
    printProductTemplatesViewModel: PrintProductTemplatesViewModel // Provided by parent component
  ) {
    super(printProductTemplatesViewModel);
  }
}
